var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { PHASE, Phases, validRoutes } from "./routeConfig";
import { Route, Switch, useLocation } from "react-router-dom";
import AgentSuccessPage from "./routes/agent-success";
import AgnecyFullfilment from "./routes/agency-fulfillment";
import AutoRoutes from "./routes/auto";
import BundleReview from "./routes/bundle-review";
import BundleReviewLinkout from "./routes/bundle-review/linkout";
import CallToShopPage from "./routes/call-to-shop";
import ConnectConsentRoute from "./routes/connect-consent";
import Header from "./components/Header";
import HomeRoutes from "./routes/home";
import InsuranceProductRoute from "./routes/insurance-product";
import { LoadingCircle } from "./components/LoadingIcon";
import MidFunnelAdsRoute from "./routes/mid-funnel-ads";
import NoPoliciesOrQuotesFoundRoute from "./routes/no-policies-or-quotes-found";
import QuoteConsentRoute from "./routes/quote-consent";
import QuoteLoadingRoute from "./routes/quote-loading";
import ReconnectSuccess from "./routes/reconnect-success";
import SavvyIntroRoute from "./routes/savvy-intro";
import ShoppingExperienceIntroPage from "./routes/shopping-experience/intro";
import ShoppingExperienceUnsupportedPage from "./routes/shopping-experience/unsupported";
import UserIntentionRoute from "./routes/user-intention";
import VerifyContactRoute from "./routes/verify-contact";
import { getMatchingPath } from "./utils/typeUtils";
import { startedJourney } from "./lib/Avo";
import useAppSelector from "./hooks/useAppSelector";
function RouteLoadingFallback() {
    return (React.createElement("div", { className: "m-auto w-[50px]" },
        React.createElement(LoadingCircle, null)));
}
export default function Routes() {
    var location = useLocation();
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var hasFiredStartedJourneyEvent = React.useRef(false);
    /**
     * We only want this event to trigger once at the start of the user journey.
     * This component does not render until the modal is open & ready so we can
     * be confident a proper path will be available
     */
    React.useEffect(function () {
        if (hasFiredStartedJourneyEvent.current)
            return;
        var path = getMatchingPath(location.pathname, validRoutes);
        if (path) {
            var page = Phases[path].page;
            var pageName = commonAnalyticsProperties.pageName, rest = __rest(commonAnalyticsProperties, ["pageName"]);
            startedJourney(__assign(__assign({}, rest), { pageName: pageName || page }));
            hasFiredStartedJourneyEvent.current = true;
        }
    }, [location.pathname, commonAnalyticsProperties]);
    return (React.createElement(React.Suspense, { fallback: React.createElement(RouteLoadingFallback, null) },
        React.createElement("div", { className: "flex grow self-stretch" },
            React.createElement("div", { className: "absolute flex h-full w-full grow flex-col overflow-hidden md:rounded-[10px] desktop:rounded-[10px]", style: {
                    padding: "env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)",
                } },
                React.createElement(Switch, { location: location },
                    React.createElement(Route, { path: PHASE.SELECT_INSURANCE_PRODUCT },
                        React.createElement(InsuranceProductRoute, null)),
                    React.createElement(Route, { path: PHASE.SELECT_USER_INTENTION },
                        React.createElement(UserIntentionRoute, null)),
                    React.createElement(Route, { path: "/auto" },
                        React.createElement(AutoRoutes, null)),
                    React.createElement(Route, { path: "/home" },
                        React.createElement(HomeRoutes, null)),
                    React.createElement(Route, { path: PHASE.SAVVY_INTRO },
                        React.createElement(SavvyIntroRoute, null)),
                    React.createElement(Route, { path: PHASE.DISCLAIMER },
                        React.createElement(ConnectConsentRoute, null)),
                    React.createElement(Route, { path: PHASE.QUOTE_CONSENT },
                        React.createElement(QuoteConsentRoute, null)),
                    React.createElement(Route, { path: PHASE.VERIFY_CONTACT },
                        React.createElement(VerifyContactRoute, null)),
                    React.createElement(Route, { path: PHASE.NO_POLICIES_OR_QUOTES_FOUND },
                        React.createElement(Header, null),
                        React.createElement(NoPoliciesOrQuotesFoundRoute, null)),
                    React.createElement(Route, { path: PHASE.QUOTE_LOADING },
                        React.createElement(QuoteLoadingRoute, null)),
                    React.createElement(Route, { path: PHASE.MID_FUNNEL_ADS },
                        React.createElement(MidFunnelAdsRoute, null)),
                    React.createElement(Route, { path: PHASE.BUNDLE_REVIEW_LINKOUT },
                        React.createElement(BundleReviewLinkout, null)),
                    React.createElement(Route, { path: PHASE.BUNDLE_REVIEW },
                        React.createElement(BundleReview, null)),
                    React.createElement(Route, { path: PHASE.AGENCY_FULFILLMENT },
                        React.createElement(AgnecyFullfilment, null)),
                    React.createElement(Route, { path: PHASE.RECONNECT_SUCCESS },
                        React.createElement(ReconnectSuccess, null)),
                    React.createElement(Route, { path: PHASE.SHOPPING_EXPERIENCE_INTRO },
                        React.createElement(ShoppingExperienceIntroPage, null)),
                    React.createElement(Route, { path: PHASE.SHOPPING_EXPERIENCE_UNSUPPORTED },
                        React.createElement(ShoppingExperienceUnsupportedPage, null)),
                    React.createElement(Route, { path: PHASE.CALL_TO_SHOP },
                        React.createElement(CallToShopPage, null)),
                    React.createElement(Route, { path: PHASE.AGENT_SUCCESS },
                        React.createElement(AgentSuccessPage, null)))))));
}
